<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      layout="vertical"
      shape="square"
      finish-button-text="Add Device"
      back-button-text="Previous"
      class="wizard-vertical mb-3"
      @on-complete="formSubmitted"
    >
      <!-- Device network -->
      <tab-content
        title="Network"
        :before-change="validationNetwork"
      >
        <validation-observer
          ref="networkValidation"
          tag="form"
        >
          <add-device-network
            :new-device="newDevice"
            @network-selected="networkSelected"
            @validation-status="updateValidationStatus"
          />
        </validation-observer>
      </tab-content>

      <!-- Device manufacturer & Model -->
      <tab-content
        title="Manufacturer & Model"
        :before-change="validationManModel"
      >
        <validation-observer
          ref="manModel"
          tag="form"
        >
          <add-device-man-model :new-device="newDevice" />
        </validation-observer>
      </tab-content>

      <!-- Device network info -->
      <tab-content
        v-if="!(network && network.networkType && network.networkType.identifier === 'virtual-network')"
        title="Network Details"
        :before-change="validationNetworkDetails"
      >
        <validation-observer
          ref="networkDetailsValidation"
          tag="form"
        >
          <add-device-network-details
            :new-device="newDevice"
            :network="network"
          />
        </validation-observer>
      </tab-content>

      <!-- Device information -->
      <tab-content
        title="Device Information"
        :before-change="validationDeviceDetails"
      >
        <validation-observer
          ref="deviceDetailsValidation"
          tag="form"
        >
          <add-device-info
            :new-device="newDevice"
            :tags="tags"
          />
        </validation-observer>
      </tab-content>

      <!-- Assign Device to Object - Check if there is any objects in the workspace -->
      <tab-content
        v-if="objects.length > 0"
        title="Assign Device to Object"
      >
        <validation-observer
          ref="deviceInfo"
          tag="form"
        />
      </tab-content>

      <!-- Device Summary -->
      <tab-content title="Device Summary">
        <validation-observer
          ref="deviceInfo"
          tag="form"
        />
        <add-device-summary
          :new-device="newDevice"
          :network="network"
        />
      </tab-content>
    </form-wizard>

    <!-- Error message -->
    <b-modal
      id="adding-device-status"
      title="Adding Device"
      hide-footer
      hide-header-close
      hide-header
      centered
      :visible="addingDevice"
    >
      <div
        v-if="!addedToNetwork"
        class="text-center mt-2"
      >
        <b-spinner
          variant="primary"
          label="Adding Device to Network"
        />
        <p class="mt-2">
          Adding Device to Network
        </p>
      </div>
      <div
        v-if="addedToNetwork"
        class="text-center mt-2"
      >
        <feather-icon
          icon="CheckCircleIcon"
          size="32"
          variant="success"
        />
        <p class="mt-2">
          Device Added to Network
        </p>
      </div>

      <div
        v-if="!addedToWorkspace"
        class="text-center mt-2"
      >
        <b-spinner
          variant="primary"
          label="Adding Device to Workspace"
        />
        <p class="mt-2">
          Adding Device to Workspace
        </p>
      </div>
      <div
        v-if="addedToWorkspace"
        class="text-center mt-2"
      >
        <feather-icon
          icon="CheckCircleIcon"
          size="32"
          variant="success"
        />
        <p class="mt-2">
          Device Added to Workspace
        </p>
      </div>

      <div
        v-if="!createdTable"
        class="text-center mt-2"
      >
        <b-spinner
          variant="primary"
          label="Creating Device Model Table in Database"
        />
        <p class="mt-2">
          Creating Device Model Table in Database
        </p>
      </div>
      <div
        v-if="createdTable"
        class="text-center"
      >
        <feather-icon
          icon="CheckCircleIcon"
          size="32"
          variant="success"
        />
        <p class="mt-2">
          Device Model Table Created in Database
        </p>
      </div>
    </b-modal>
  </div>
</template>

<script>
// eslint-disabel
import { BModal, BSpinner } from 'bootstrap-vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import { ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { API } from 'aws-amplify'
import { datadogLogs } from '@datadog/browser-logs'
import { v4 as uuidv4 } from 'uuid'
import * as mutations from '../../../graphql/mutations'
import * as queries from '../../../graphql/queries'
import AddDeviceNetwork from './AddDeviceNetwork.vue'
import AddDeviceNetworkDetails from './AddDeviceNetworkDetails.vue'
import AddDeviceManModel from './AddDeviceManModel.vue'
import AddDeviceInfo from './AddDeviceInfo.vue'
import AddDeviceSummary from './AddDeviceSummary.vue'

export default {
  components: {
    ValidationObserver,
    FormWizard,
    TabContent,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    AddDeviceNetwork,
    AddDeviceNetworkDetails,
    AddDeviceManModel,
    AddDeviceInfo,
    AddDeviceSummary,
    BModal,
    BSpinner,
  },
  data() {
    return {
      objects: [],
      tags: [],
      network: {},
      workspacetoken: '',
      newDevice: {
        network: {
          name: '',
          appEUI: '',
          appKey: '',
          devEUI: '',
          applicationId: '',
          deviceProfileId: '',
        },
        deviceInfo: {
          id: '',
          name: '',
          deviceManufacturer: '',
          deviceModelID: '',
          deviceModelName: '',
          deviceModelNumber: '',
          deviceManufacturerSerialNumber: '',
          sensors: [],
          tags: [],
          position: '',
          site_id: '',
          object_id: '',
          imgLink: '',
        },
      },
      createdDevice: {},
      addDeviceError: '',
      addingDevice: false,
      addedToNetwork: false,
      addedToWorkspace: false,
      createdTable: false,
      isNetworkSelectionValid: false,
    }
  },
  watch: {
    newDevice: {
      deep: true,
      handler(newVal) {
        this.newDevice = newVal
      },
    },
  },
  created() {
    // this.listObjects()
    // this.listTags()
    this.getWorkspaceToken()
  },
  methods: {
    async getWorkspaceToken() {
      await API.graphql({
        query: queries.getWorkspace,
        variables: {
          id: JSON.parse(localStorage.getItem('workspace')).id,
        },
      }).then(response => {
        this.workspacetoken = response.data.getWorkspace.workspacetoken
      })
    },
    async listObjects() {
      const { currentWorkspace } = JSON.parse(localStorage.getItem('userData'))
      await API.graphql({
        query: queries.listObjects,
        filter: { workspace: { eq: currentWorkspace } },
      }).then(response => {
        this.objects = response.listObjects.items
      })
    },
    async listTags() {
      const { currentWorkspace } = JSON.parse(localStorage.getItem('userData'))
      await API.graphql({
        query: queries.listTags,
        filter: { workspace: { eq: currentWorkspace } },
      }).then(response => {
        this.tags = response.data.listTags.items
      })
    },
    updateSiteTypes(val) {
      this.siteTypes = val
    },
    updateTags(val) {
      this.tags = val
    },
    triggerToast(title, variant, icon) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title,
            icon,
            variant,
          },
        },
        {
          position: 'bottom-right',
        },
      )
    },
    async addDeviceToNetwork() {
      if (this.network.networkType.identifier === 'prym-helium') {
        // Define query and body for the API call
        const query = {
          'Content-Type': 'application/json',
          network: this.network.networkType.identifier,
          apiKey: this.network.api_key,
        }
        const body = {
          name: this.newDevice.deviceInfo.name,
          app_eui: this.newDevice.network.appEUI,
          app_key: this.newDevice.network.appKey,
          dev_eui: this.newDevice.network.devEUI,
        }

        try {
          // Send a POST request to add the device to the network
          const response = await API.post('NetworkAPI', '/devices', {
            queryStringParameters: query,
            body,
          })

          // Handle errors in the response
          if (response.data.errors) {
            [this.addDeviceError] = response.data.errors.message
            datadogLogs.logger.error('Error adding device to network', {
              error: this.addDeviceError,
            })
            return null
          }

          // Update the state and trigger a success toast
          this.createdDevice = response
          this.addedToNetwork = true
          this.triggerToast('Device Added to Network', 'success', 'Check')
          datadogLogs.logger.info('Device added to network', {
            device: response.data,
          })

          // Return the device ID from the response
          return response.data.id
        } catch (error) {
          // Log the error and update the state
          datadogLogs.logger.error('Error adding device to network', { error })
          this.addDeviceError = error
        }
      }

      if (this.network.networkType.identifier === 'tts') {
        // Generate a new device ID
        const deviceId = uuidv4()
        // Get workspace data from local storage
        const workspace = JSON.parse(localStorage.getItem('workspace'))
        const workspaceId = workspace.id
        // Construct the application ID
        const applicationId = `${this.newDevice.deviceInfo.deviceModelID.substring(
          0,
          8,
        )}-${workspaceId.substring(0, 23)}`
        const queryParams = {
          apiEndpoint: this.network.networkType.apiEndpoint,
          apiKey: this.network.api_key,
          applicationId,
        }

        try {
          // Check if the application exists
          const appExists = await API.get('NetworkAPI', '/applications', {
            headers: {
              'Content-Type': 'application/json',
            },
            queryStringParameters: queryParams,
          })

          // If the application does not exist, create it
          if (appExists?.applications?.ids?.application_id !== applicationId) {
            try {
              await API.post('NetworkAPI', '/applications', {
                headers: {
                  'Content-Type': 'application/json',
                },
                queryStringParameters: {
                  apiEndpoint: this.network.networkType.apiEndpoint,
                  apiKey: this.network.api_key,
                },
                body: {
                  organizationId: workspaceId,
                  applicationId,
                  applicationName: this.newDevice.deviceInfo.deviceModelName,
                },
              })
            } catch (error) {
              this.addDeviceError = error
            }
          }

          // Add the device to the network
          try {
            let queryStringParameters = {}
            let body = {}

            queryStringParameters = {
              network: this.network.networkType.identifier,
              apiEndpoint: this.network.networkType.apiEndpoint,
              apiKey: this.network.api_key,
            }
            body = {
              name: this.newDevice.deviceInfo.name,
              device_id: deviceId,
              appId: applicationId,
              join_eui: this.newDevice.network.appEUI,
              dev_eui: this.newDevice.network.devEUI,
              app_key: this.newDevice.network.appKey,
            }
            await API.post('NetworkAPI', '/devices', {
              headers: {
                'Content-Type': 'application/json',
              },
              queryStringParameters,
              body,
            })

            // Set addedToNetwork flag and trigger a success toast
            this.addedToNetwork = true
            this.triggerToast('Device Added to Network', 'success', 'Check')
          } catch (error) {
            this.addDeviceError = error
          }
        } catch (error) {
          this.addDeviceError = error
        }

        // Return the generated device ID
        return deviceId
      }
      if (this.network.networkType.identifier === 'prym-chirpstack') {
        const deviceId = this.newDevice.network.devEUI.toLowerCase()
        const queryStringParameters = {
          network: this.network.networkType.identifier,
          endpoint: this.network.networkType.apiEndpoint,
          apiKey: this.network.api_key,
          deviceProfileId: this.newDevice.network.deviceProfileId,
          applicationId: this.newDevice.network.applicationId,
          name: this.newDevice.deviceInfo.name,
          devEui: this.newDevice.network.devEUI,
          appKey: this.newDevice.network.appKey,
          joinEui: this.newDevice.network.appEUI,
        }
        try {
          await API.post('NetworkAPI', '/devices', {
            headers: {
              'Content-Type': 'application/json',
            },
            queryStringParameters,
            body: {
              device_id: deviceId,
            },
          })

          // Set addedToNetwork flag and trigger a success toast
          this.addedToNetwork = true
          this.triggerToast('Device Added to Network', 'success', 'Check')
        } catch (error) {
          this.addDeviceError = error
          this.addedToNetwork = false

          if (error.response && error.response.status === 500) {
            // Parse the error response
            const errorResponse = error.response.data
            if (errorResponse && errorResponse.error) {
              // Display the specific error message to the user
              this.addDeviceError = errorResponse.error
              this.triggerToast(errorResponse.error, 'danger', 'InfoIcon')
            } else {
              // Handle other types of errors
              this.addDeviceError = 'An error occurred while adding the device.'
            }
          } else {
            // Handle other types of errors
            this.addDeviceError = 'An error occurred while adding the device.'
          }
        }
        return deviceId
      }

      return null
    },

    async addDeviceToWorkspace(workspaceId, deviceId) {
      const roles = ['admin', 'editor', 'viewer']
      const workspaceGroups = []
      roles.forEach(role => {
        workspaceGroups.push(`${workspaceId}.${role}`)
      })
      const addDevice = {}
      if (deviceId !== '') addDevice.id = deviceId
      if (workspaceGroups !== '') addDevice.workspaceGroups = workspaceGroups
      if (workspaceId !== '') addDevice.workspaceDevicesId = workspaceId
      if (this.newDevice.deviceInfo.name !== '') addDevice.name = this.newDevice.deviceInfo.name
      if (this.newDevice.deviceInfo.deviceManufacturerSerialNumber !== '') addDevice.manufacturerSerialNumber = this.newDevice.deviceInfo.deviceManufacturerSerialNumber
      if (this.newDevice.network.appEUI !== '') addDevice.app_eui = this.newDevice.network.appEUI
      if (this.newDevice.network.appKey !== '') addDevice.app_key = this.newDevice.network.appKey
      if (this.newDevice.network.devEUI !== '') addDevice.dev_eui = this.newDevice.network.devEUI
      if (this.newDevice.deviceInfo.deviceModelID !== '') addDevice.deviceModelDevicesId = this.newDevice.deviceInfo.deviceModelID
      if (this.network.id !== '') addDevice.networkDevicesId = this.network.id

      await API.graphql({
        query: mutations.createDevice,
        variables: {
          input: addDevice,
        },
      }).then(res => {
        if (res.errors) {
          this.triggerToast(res.errors[0], 'danger', 'InfoIcon')
        } else {
          this.triggerToast(
            `${res.data.createDevice.name} created`,
            'success',
            'InfoIcon',
          )
          this.addedToWorkspace = true
          this.createdDevice = res.data.createDevice
        }
      })
    },
    async createTimestreamTable(workspaceId) {
      const apiName = 'TimestreamAPI'
      const path = '/table'
      const myInit = {
        headers: {
          workspace: workspaceId,
          workspacetoken: this.workspacetoken,
        },
        body: {
          deviceModelID: this.newDevice.deviceInfo.deviceModelID,
        },
      }
      await API.post(apiName, path, myInit)
        .then(() => {
          this.createdTable = true
          datadogLogs.logger.info(
            `Timestream Table created for ${this.newDevice.deviceInfo.name}`,
          )
        })
        .catch(error => {
          datadogLogs.logger.error('Error creating Timestream Table: ', error)
          this.triggerToast(error, 'danger', 'InfoIcon')
        })
    },
    async formSubmitted() {
      this.addingDevice = true
      // eslint-disable-next-line no-unused-vars
      const workspace = JSON.parse(localStorage.getItem('workspace'))
      // eslint-disable-next-line no-unused-vars
      if (this.network.networkType.identifier !== 'virtual-network') {
        const deviceId = await this.addDeviceToNetwork()
        await this.addDeviceToWorkspace(workspace.id, deviceId)
        await this.createTimestreamTable(workspace.id)
      } else if (this.network.networkType.identifier === 'prym-chirpstack') {
        const deviceId = await this.addDeviceToNetwork()
        await this.addDeviceToWorkspace(workspace.id, deviceId)
        await this.createTimestreamTable(workspace.id)
      } else {
        const deviceId = uuidv4()
        this.addedToNetwork = true
        await this.addDeviceToWorkspace(workspace.id, deviceId)
        await this.createTimestreamTable(workspace.id)
      }
      this.$router.push('/devices')
    },
    networkSelected(network) {
      this.network = network
    },
    async validationManModel() {
      const isValid = await this.$refs.manModel.validate()
      return isValid
    },
    updateValidationStatus(isValid) {
      this.isNetworkSelectionValid = isValid
    },
    async validationNetwork() {
      return this.isNetworkSelectionValid
    },
    async validationNetworkDetails() {
      const isValid = await this.$refs.networkDetailsValidation.validate()
      return isValid
    },
    async validationDeviceDetails() {
      const isValid = await this.$refs.deviceDetailsValidation.validate()
      return isValid
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>
